import type { ReactNode } from 'react';

import { cn } from '../lib/cn.ts';
import { Card } from './card.tsx';

/** Блок страницы настроек: заголовок, пояснение, действие справа и содержимое. */
export function SettingsSection({
  title,
  lead,
  action,
  children,
  className,
}: {
  title: ReactNode;
  lead?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <Card className={cn('flex flex-col', className)}>
      <header className="flex flex-wrap items-start justify-between gap-3 px-4 pt-3.5 pb-3">
        <div className="flex min-w-0 flex-col gap-0.5">
          <h2 className="font-display text-title font-bold">{title}</h2>
          {lead ? <p className="max-w-[60ch] text-small text-muted">{lead}</p> : null}
        </div>
        {action ? <div className="flex shrink-0 gap-2">{action}</div> : null}
      </header>
      {children ? <div className="border-t border-border-soft px-4 py-3.5">{children}</div> : null}
    </Card>
  );
}
